var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
__export(exports, {
  default: () => Chains
});
var import_lodash = __toModule(require("lodash"));
var import_chain = __toModule(require("./chain"));
var import_util = __toModule(require("./util"));
class Chains {
  constructor() {
    this.names = null;
    this.cachedChainSpecs = {};
  }
  all() {
    return __async(this, null, function* () {
      if (this.names === null)
        this.names = yield (0, import_util.fetchRawFileContents)(`manifest.json`);
      return this.names;
    });
  }
  chainById(id) {
    return __async(this, null, function* () {
      id = id.toString();
      const chainManifest = yield this.all();
      const chainIds = Object.keys(chainManifest);
      if (!chainIds.includes(id))
        throw new Error(`Chain ${id} not supported`);
      let chain = this.cachedChainSpecs[id];
      if (!chain) {
        chain = new import_chain.default(id);
        yield chain.init();
        this.cachedChainSpecs[id] = chain;
      }
      return chain;
    });
  }
  chainFieldById(id, field) {
    return __async(this, null, function* () {
      const chain = yield this.chainById(id);
      const fields = typeof field === "string" ? [field] : field;
      const values = {};
      fields.forEach((key) => {
        values[key] = (0, import_lodash.get)(chain, field);
      });
      return values;
    });
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
